"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styledComponents = require("styled-components");

var _Logo = require("./Logo.styles");

var _Cake_Logo = _interopRequireDefault(require("../../../styles/images/Cake_Logo.svg"));

var _Cake_Logo_white = _interopRequireDefault(require("../../../styles/images/Cake_Logo_white.svg"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function () { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/**
 * Logo component
 */
var Logo = /*#__PURE__*/function (_React$PureComponent) {
  _inherits(Logo, _React$PureComponent);

  var _super = _createSuper(Logo);

  function Logo(props) {
    var _this;

    _classCallCheck(this, Logo);

    _this = _super.call(this, props);
    _this.onClickHandler = _this.onClickHandler.bind(_assertThisInitialized(_this));
    var image = props.image,
        inverse = props.inverse;
    _this.state = {
      logoSrc: function () {
        // if something is passed in as a prop, it trumps all others
        if (image) {
          return image;
        } // if an image is set on the theme, use it


        if (_this.props.theme.logo || inverse && _this.props.theme.logoInverse) {
          if (_this.props.theme.logoInverse) {
            return _this.props.theme.logoInverse;
          }

          return _this.props.theme.logo;
        } // if we have none of that, default to the cake logos


        if (inverse) {
          return _Cake_Logo_white.default;
        }

        return _Cake_Logo.default;
      }()
    };
    return _this;
  }

  _createClass(Logo, [{
    key: "onClickHandler",
    value: function onClickHandler() {
      return this.props.onClick();
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          className = _this$props.className,
          dataTestId = _this$props.dataTestId,
          disabled = _this$props.disabled,
          mobile = _this$props.mobile,
          props = _objectWithoutProperties(_this$props, ["className", "dataTestId", "disabled", "mobile"]);

      var logoSrc = this.state.logoSrc;
      return /*#__PURE__*/_react.default.createElement(_Logo.StyledLogo, _extends({
        className: className,
        "data-test-id": dataTestId,
        disabled: disabled,
        onClick: this.onClickHandler,
        type: "button"
      }, props), /*#__PURE__*/_react.default.createElement("img", {
        className: mobile ? 'c-logo-img-mobile' : 'c-logo-img',
        src: logoSrc,
        alt: "Logo"
      }));
    }
  }]);

  return Logo;
}(_react.default.PureComponent);

_defineProperty(Logo, "propTypes", {
  /** Hook for overriding top-level component styles */
  className: _propTypes.default.string,

  /** Test ID hook */
  dataTestId: _propTypes.default.string.isRequired,

  /** disabling flag modifies visibility and click-ability */
  disabled: _propTypes.default.bool,

  /** image to display as the logo */
  image: _propTypes.default.string,

  /** A boolean to use the white cake logo */
  inverse: _propTypes.default.bool,

  /** mobile flag - renders a smaller image */
  mobile: _propTypes.default.bool,
  theme: _propTypes.default.shape({
    logo: _propTypes.default.string,
    logoInverse: _propTypes.default.string
  }),

  /** function to invoke upon being clicked */
  onClick: _propTypes.default.func
});

_defineProperty(Logo, "defaultProps", {
  className: '',
  disabled: false,
  image: null,
  inverse: false,
  mobile: false,
  theme: {
    logo: undefined,
    logoInverse: undefined
  },
  onClick: function onClick() {}
});

var _default = (0, _styledComponents.withTheme)(Logo);

exports.default = _default;